import React, { Component } from 'react'
import { BaseEntityPage } from '../BaseEntityPage';
import { ApiHelper } from '../../helpers/ApiHelper';
import { Helper } from '../../helpers/Helper';
import { css, StyleSheet } from 'aphrodite';
import { AppTheme } from '../../../styles/AppTheme';
import { Button, Grid, Paper, Select, Input, MenuItem, Chip, Checkbox } from '@material-ui/core';
import { Controller } from '../../Controller';
import { TableComponent } from '../TableComponent';

export class RespondV2 extends BaseEntityPage {
  constructor(props) {
    super(props)
    this.pageTitle = 'RespondV2'
    const user = Controller.get().userMgr().getAppUser()
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['respcontexts', user.responseId], {}) },
    ]
    this.questionTableHeadersMap = {
      type: current => QuestionTypes[current.type].label,
      question: current => current.title,
      answer: current => {
        current.value = current.value || ''
        if(current.type === 'YESNO' || current.type === 'OPTIONS-MUL' || current.type === 'OPTIONS-SINGLE') {
          if (current.type === 'OPTIONS-MUL') {
            current.__multiSelect = true
            current.value = current.value || []
          }
          return this.multiSelectField(current)
        } else {
          return this.textField(current)
        }
      }
    }
  }
  multiSelectField = (current) => {

    const options = []
    const qOptions = Object.values(current.options)
    for (const option of qOptions) {
      let cbOption = '';
      if (current.__multiSelect) {
        cbOption = <Checkbox color='primary' checked={current.value.indexOf(option.id) > -1} />
      }
      options.push(
        <MenuItem key={option.id} value={option.id}>
          {cbOption}
          {option.title}
        </MenuItem>
      );
    }
    let renderParams = {}
    if (current.__multiSelect) {
      const searchOptions = qOptions
      renderParams = {
        renderValue: selected => (
          <div className={css(Styles.chips)}>
            {selected.map(value => {
              return this.findValueInList(value, searchOptions)
            })}
          </div>
        )
      }
    }
    return <Select
      multiple={current.__multiSelect}
      value={current.value}
      onChange={this.handleSelectChange(current)}
      {...renderParams}
      fullWidth={true}
      input={<Input name={current.id + ''} id={current.id + ''} disabled={this.shouldDisable()} />}
    >
      {options}
    </Select>
  }
  textField = (current) => {
    return (
      <Input
        name={current.id + ''}
        id={current.id + ''}
        disabled={this.shouldDisable()}
        value={current.value}
        onChange={this.handleInputChange(current)}
        fullWidth={true}
      />
    )
  }
  findValueInList(value, searchOptions) {
    const found = searchOptions.find(o => o.id === value)
    if (found) {
      return (<Chip key={value} label={found.title} />)
    }
  }
  handleSelectChange = (current) => (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    current.value = value
    this.setState({
      forceRender: !this.state.forceRender
    })
  }
  handleInputChange = (current) => (event) => {
    const target = event.target
    const value = target.value
    const id = target.id
    current.value = value
    this.setState({
      forceRender: !this.state.forceRender
    })
  }

  shouldDisable() {
    return false
  }
  onFetchSuccess(results) {
    console.log('results:', results)

    const sectionsMap = results[0][0] || {}
    const sections = Object.values(sectionsMap)
    sections.forEach(section => {
      Helper.sortDictArrayRev(section.subSections)
    })
    Helper.sortDictArrayRev(sections)

    const responses = results[0][1].items || []
    const responseMap = {}
    responses.forEach(item => {
      responseMap[item.questionId] = item
    })

    const context = results[0][2] || {}

    this.setState({
      sections,
      sectionsMap,
      responseMap,
      smallTiles: []
    })
  }
  selectSection(tile) {
    const subSections = tile.subSections
    if (this.state.selectedSection === tile) {
      return this.setState({
        selectedSection: null,
        smallTiles: [],
        selectedSubSection: null,
        selectedQuestions: [],
        selectedRootQuestions: null,
        selectedGroups: null
      })
    }
    this.setState({
      selectedSection: tile,
      smallTiles: subSections,
      selectedSubSection: null,
      selectedQuestions: [],
      selectedRootQuestions: null,
      selectedGroups: null
    })
  }
  selectSubSection(tile) {
    if (this.state.selectedSubSection === tile) {
      return this.setState({
        selectedSubSection: null,
        selectedQuestions: [],
        selectedRootQuestions: null,
        selectedGroups: null
      })
    }
    const {questions} = tile
    if (questions) {
      this.setState({
        selectedSubSection: tile,
        selectedQuestions: questions,
        selectedRootQuestions: tile.selectedRootQuestions,
        selectedGroups: tile.selectedGroups
      })
    } else {
      this.setState({
        fetchState: ApiHelper.State.LOADING
      })
      const queryParams = {
        groupId: tile.id
      }
      ApiHelper.call({ method: 'GET', endPoint: ApiHelper.makeUrlPath(['questions'], queryParams)}, (err, data) => {
        if (err) {
          return this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
        }
        tile.questions = data.items
        const selectedRootQuestions = []
        const selectedGroups = {}
        tile.questions.forEach(question => {
          if (!question.tag) {
            return selectedRootQuestions.push(question)
          }
          if (selectedGroups[question.tag]) {
            selectedGroups[question.tag].push(question)
          } else {
            selectedGroups[question.tag] = [question]
          }
        })
        tile.selectedRootQuestions = selectedRootQuestions
        tile.selectedGroups = selectedGroups
        this.setState({
          fetchState: ApiHelper.State.READY,
          selectedSubSection: tile,
          selectedQuestions: tile.questions,
          selectedRootQuestions,
          selectedGroups
        })
      })
    }
  }
  renderQuiz = () => {
    const {selectedRootQuestions, selectedGroups } = this.state
    if (!selectedRootQuestions) {
      return
    }
    return (
      <TableComponent
        tableHeadersMap={this.questionTableHeadersMap}
        items={selectedRootQuestions}
      />
    )
  }
  renderCustomReady = () => {
    const {sections} = this.state
    const largeTiles = sections

    return (
      <div className={css(Styles.content)}>
        <Grid container spacing={24} className={css(Styles.container)}>
          {largeTiles.map(tile => (
            // <Grid key={tile.title} item xs={6} sm={12 / largeTiles.length}>
            <Grid key={tile.title} item xs={6} sm={3}>
              <Button
                className={css(Styles.link)}
                onClick={() => this.selectSection(tile)}
              >
                <Paper className={css(Styles.tile)}>
                  <h2 className={css(Styles.title)}>{tile.title}</h2>
                </Paper>
              </Button>
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          spacing={24}
          className={css(Styles.container, Styles.subSections)}
        >
          {this.state.smallTiles.map(tile => (
            // <Grid key={tile.title} item xs={6} sm={12 / this.state.smallTiles.length}>
            <Grid key={tile.title} item xs={6} sm={3}>
              <Button
                className={css(Styles.link)}
                onClick={() => this.selectSubSection(tile)}
              >
                <Paper className={css(Styles.smallTile)}>
                  <h2 className={css(Styles.title)}>{tile.title}</h2>
                </Paper>
              </Button>
            </Grid>
          ))}
        </Grid>
        {this.renderQuiz()}
      </div>
    )
  }
}

const QuestionTypes = {
  YESNO: { key: 'YESNO', label: 'Yes/No', value: false },
  'OPTIONS-MUL': { key: 'OPTIONS-MUL', label: 'Options - Multiple Answers', value: false },
  'OPTIONS-SINGLE': { key: 'OPTIONS-SINGLE', label: 'Options - Single Answer', value: false },
  'TEXT-SHORT': { key: 'TEXT-SHORT', label: 'Short Answer', value: false },
  'TEXT-PARA': { key: 'TEXT-PARA', label: 'Long Answer', value: false },
  DATE: { key: 'DATE', label: 'Answer is a Date', value: false },
  INT: { key: 'INT', label: 'Answer is a Number', value: false },
  FLOAT: { key: 'FLOAT', label: 'Answer is a Float', value: false },
  TIME: { key: 'TIME', label: 'Answer is a Time (12 hr, AM/PM toggle)', value: false }
}

const Styles = StyleSheet.create({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // maxWidth: AppTheme.viewPort,
    width: '100%',
    paddingTop: 20,
    backgroundColor: 'whitesmoke'
  },
  container: {
    textAlign: 'center',
    maxWidth: 900
  },
  subSections: {
    paddingTop: 50
  },
  tile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 100,

    borderTop: '3px solid ' + AppTheme.secondaryColor,
    minHeight: 80,
    backgroundColor: 'whitesmoke',
    '@media (max-width: 600px)': {
      minHeight: 60,
    }
  },
  smallTile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    borderTop: '1px solid ' + AppTheme.secondaryColor,
    minHeight: 80,
    backgroundColor: 'whitesmoke',
    '@media (max-width: 600px)': {
      minHeight: 50,
    }
  },
  title: {
    fontSize: 16,
    fontWeight: 'normal',
    textTransform: 'uppercase',
    paddingLeft: 16,
    paddingRight: 16,
    minWidth: 150
  },
  link: {
    textDecoration: 'none',
    color: 'black'
  }
})


// WEBPACK FOOTER //
// ./src/common/components/quizresponder/RespondV2.js